import clsx from 'clsx'
import {FC} from 'react'
import {Row} from 'react-table'
import {DataCSRItem} from '../../core/_models'

type Props = {
  row: Row<DataCSRItem>
}

const CustomRow: FC<Props> = ({row}) => (
  <tr {...row.getRowProps()}>
    {row.cells.map((cell) => {
      return (
        <td {...cell.getCellProps()} className={clsx({'text-center': cell.column.id === 'actions'})}>
          <>{cell.render('Cell')}</>
        </td>
      )
    })}
  </tr>
)

export {CustomRow}
